export default {
  title: 'Taxe și valută',
  subtitle: 'Gestionați categoriile fiscale utilizate pentru prețurile articolelor din meniu.',
};
